export default "__VITE_ASSET__15318415__"